export default __webpack_public_path__ + "static/media/rightArrow.7aab2ada.svg";